function escapeHtml(text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function parseInline(text) {
  var s = text;
  s = s.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" style="max-width:100%" />');
  s = s.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  s = s.replace(/~~(.+?)~~/g, '<del>$1</del>');
  s = s.replace(/==(.+?)==/g, '<mark>$1</mark>');
  s = s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/\*(.+?)\*/g, '<em>$1</em>');
  s = s.replace(/`(.+?)`/g, '<code>$1</code>');
  s = s.replace(/X\^(\w+)\^/g, 'X<sup>$1</sup>');
  s = s.replace(/(\w)\^(\w+)\^/g, '$1<sup>$2</sup>');
  s = s.replace(/(\w)~(\w+)~/g, '$1<sub>$2</sub>');
  return s;
}

export default function parseMarkdown(md) {
  var lines = md.split('\n');
  var html = '';
  var i = 0;
  var inUl = false, inOl = false, inBlockquote = false, inTable = false;

  function closeList() {
    if (inUl) { html += '</ul>'; inUl = false; }
    if (inOl) { html += '</ol>'; inOl = false; }
  }
  function closeBlockquote() {
    if (inBlockquote) { html += '</blockquote>'; inBlockquote = false; }
  }
  function closeTable() {
    if (inTable) { html += '</tbody></table>'; inTable = false; }
  }

  while (i < lines.length) {
    var line = lines[i];

    if (line.trim().startsWith('```')) {
      closeList(); closeBlockquote(); closeTable();
      var code = '';
      i++;
      while (i < lines.length && !lines[i].trim().startsWith('```')) {
        code += escapeHtml(lines[i]) + '\n';
        i++;
      }
      html += '<pre><code>' + code.trimEnd() + '</code></pre>';
      i++;
      continue;
    }

    if (/^(-{3,}|\*{3,}|_{3,})$/.test(line.trim())) {
      closeList(); closeBlockquote(); closeTable();
      html += '<hr />';
      i++;
      continue;
    }

    var headingMatch = line.match(/^(#{1,6})\s+(.+?)(?:\s+\{#[\w-]+\})?$/);
    if (headingMatch) {
      closeList(); closeBlockquote(); closeTable();
      var level = headingMatch[1].length;
      html += '<h' + level + '>' + parseInline(headingMatch[2]) + '</h' + level + '>';
      i++;
      continue;
    }

    if (line.includes('|') && line.trim().startsWith('|')) {
      closeList(); closeBlockquote();
      var cells = line.split('|').filter(function (c, idx, arr) { return idx > 0 && idx < arr.length - 1; });
      if (!inTable) {
        if (i + 1 < lines.length && /^\|[\s:-]+\|/.test(lines[i + 1].trim())) {
          html += '<table><thead><tr>' + cells.map(function (c) { return '<th>' + parseInline(c.trim()) + '</th>'; }).join('') + '</tr></thead><tbody>';
          inTable = true;
          i += 2;
          continue;
        }
      }
      if (inTable) {
        html += '<tr>' + cells.map(function (c) { return '<td>' + parseInline(c.trim()) + '</td>'; }).join('') + '</tr>';
        i++;
        continue;
      }
    } else {
      closeTable();
    }

    if (line.trim().startsWith('> ')) {
      closeList(); closeTable();
      if (!inBlockquote) { html += '<blockquote>'; inBlockquote = true; }
      html += '<p>' + parseInline(line.trim().substring(2)) + '</p>';
      i++;
      continue;
    } else {
      closeBlockquote();
    }

    var taskMatch = line.match(/^[-*]\s+\[([ xX])\]\s+(.+)$/);
    if (taskMatch) {
      closeTable(); closeBlockquote();
      if (!inUl) { html += '<ul class="task-list">'; inUl = true; }
      var checked = taskMatch[1] !== ' ' ? ' checked disabled' : ' disabled';
      html += '<li><input type="checkbox"' + checked + ' /> ' + parseInline(taskMatch[2]) + '</li>';
      i++;
      continue;
    }

    if (/^[-*]\s+/.test(line.trim())) {
      closeTable(); closeBlockquote();
      if (inOl) { html += '</ol>'; inOl = false; }
      if (!inUl) { html += '<ul>'; inUl = true; }
      html += '<li>' + parseInline(line.trim().replace(/^[-*]\s+/, '')) + '</li>';
      i++;
      continue;
    }

    var olMatch = line.trim().match(/^\d+\.\s+(.+)$/);
    if (olMatch) {
      closeTable(); closeBlockquote();
      if (inUl) { html += '</ul>'; inUl = false; }
      if (!inOl) { html += '<ol>'; inOl = true; }
      html += '<li>' + parseInline(olMatch[1]) + '</li>';
      i++;
      continue;
    }

    closeList();

    if (line.trim() === '') {
      i++;
      continue;
    }

    closeTable(); closeBlockquote();
    html += '<p>' + parseInline(line) + '</p>';
    i++;
  }

  closeList();
  closeBlockquote();
  closeTable();
  return html;
}
